const validateXeroSettings = (values) => {
  const errors = {};

  if (values?.invoice_status === "") {
    errors.invoice_status = "Required";
  }
  if (values?.revenue_account === "") {
    errors.revenue_account = "Required";
  }
  if (values?.retention_revenue_account === "") {
    errors.retention_revenue_account = "Required";
  }
  if (
    values?.tracking_category_name !== "" &&
    values?.tracking_category_code === ""
  ) {
    errors.tracking_category_code = "Required";
  }
  return errors;
};

export default validateXeroSettings;
